module.exports = __webpack_public_path__ + "img/38.b468b61b.png";